import { Button } from 'antd'
import { ReactComponent as BackArrow } from 'assets/icons/back-arrow.svg'
import backgroundSrc from 'assets/img/greeting-background.png'
import { COLORS } from 'constants/colors'
import { device } from 'constants/responsive'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  height: 110px;
  padding: 24px 40px 24px 24px;
  margin-bottom: 40px;

  background-image: url(${backgroundSrc});
  background-position: right bottom;
  background-size: cover;
  background-repeat: no-repeat;

  border: 0.5px solid #d9ecf6;
  border-radius: 12px;

  @media ${device.tablet} {
    height: auto;
    padding: 12px 20px 12px 12px;
    margin-bottom: 20px;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  height: 62px;
  width: 62px;

  margin-right: 16px;

  background-color: rgba(255, 255, 255, 0.5);
  border: 1.5px solid #ffffff;
  border-radius: 50%;

  @media ${device.tablet} {
    height: 50px;
    width: 50px;

    margin-right: 8px;
  }
`

export const Title = styled.p`
  font-size: 20px;
  line-height: 1.2;
  font-weight: 500;
  color: ${COLORS.text.default};

  margin-bottom: 8px;

  @media ${device.tablet} {
    font-size: 16px;

    margin-bottom: 4px;
  }
`

export const Subtitle = styled.p`
  font-size: 18px;
  line-height: 1.2;
  color: #425486;

  @media ${device.tablet} {
    font-size: 14px;
  }
`

export const ActionButton = styled(Button)`
  width: 140px;
  height: 44px;

  line-height: inherit;

  @media ${device.tablet} {
    display: none;
  }
`

export const RightArrow = styled(BackArrow)`
  transform: rotate(180deg);
`
